import gql from "graphql-tag";
import { useApolloGqlMutation } from "frontend/hooks/useApolloGql/useApolloGqlMutation.js";

// GQL
const REJECT_PHOTO_UPLOAD_TITLE = gql`
    mutation rejectPhotoUploadTitle($photoUploadId: ID!) {
        payload: rejectPhotoUploadTitle(photoUploadId: $photoUploadId) {
            errors
            ok
            photoUpload {
                photoTitleApproved
                photoTitle
            }
        }
    }
`;

export const useRejectPhotoUploadTitle = () => {
    return useApolloGqlMutation({
        actionDesc: "Reject Photo Upload Title",
        gql: REJECT_PHOTO_UPLOAD_TITLE
    });
};
